import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import API_URL from '../config/api';

const GuarantorConfirmation = () => {
    const navigate = useNavigate();
    const { loanId, guarantorId } = useParams();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleConfirm = async () => {
        setLoading(true);
        setError('');

        try {
            await axios.post(
                `${API_URL}/api/guarantors/${guarantorId}/confirm`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`
                    }
                }
            );

            navigate('/dashboard');
        } catch (err) {
            setError(err.response?.data?.msg || 'Failed to confirm guarantee');
            setLoading(false);
        }
    };

    const handleReject = async () => {
        setLoading(true);
        setError('');

        try {
            await axios.post(
                `${API_URL}/api/guarantors/${guarantorId}/reject`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`
                    }
                }
            );

            navigate('/dashboard');
        } catch (err) {
            setError(err.response?.data?.msg || 'Failed to reject guarantee');
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full space-y-8">
                <div>
                    <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
                        Confirm Guarantee
                    </h2>
                    <p className="mt-2 text-center text-sm text-gray-600">
                        You have been requested to guarantee a loan application.
                    </p>
                </div>

                {error && (
                    <div className="bg-red-100 text-red-700 p-4 rounded mb-4">
                        {error}
                    </div>
                )}

                <div className="mt-8">
                    <div className="rounded-md shadow-sm -space-y-px">
                        <button
                            onClick={handleConfirm}
                            disabled={loading}
                            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                        >
                            {loading ? 'Confirming...' : 'Confirm Guarantee'}
                        </button>
                        <button
                            onClick={handleReject}
                            disabled={loading}
                            className="mt-4 w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                        >
                            {loading ? 'Rejecting...' : 'Reject Guarantee'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GuarantorConfirmation;
